const DEVICE_TYPE_STRING_MAP = {
  tv: 'Connected TV',
  desktop: 'Desktop',
  phone: 'Smart Phone',
  tablet: 'Tablet',
  'set-top-box': 'Set Top Box',
} as const;

export const mapDeviceTypeStringsToNames = (deviceTypeString: string): string => {
  if (!deviceTypeString) {
    return '';
  }

  const deviceTypes = deviceTypeString.split(',').map(str => str.trim());
  const mappedNames = deviceTypes.map(
    deviceType => DEVICE_TYPE_STRING_MAP[deviceType as keyof typeof DEVICE_TYPE_STRING_MAP] || deviceType
  );

  return mappedNames.join(', ');
};
